import React, {Component} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class FeaturedNews extends Component {

componentWillMount(){

}

render() {
     var data = this.props;
     if(
       Object.keys(data).length>0
     ){
       return (
            <div className="col-md-4">
                 {data.thumbnail&&data.thumbnail.length > 0 && <a href={`/news-events/${data.type.toLowerCase()}/${data.id}`}><img alt={data.title} src={data.thumbnail[0].url} /></a>}
                 <h3 className="pb-4 text-dark pt-2">{data.type}</h3>
                 <h4 className="text-primary"><a className="text-primary" href={`/news-events/${data.type.toLowerCase()}/${data.id}`}>{data.title}</a></h4>
                 <h5 className="text-light"><FontAwesomeIcon icon="calendar"></FontAwesomeIcon> {data.date}</h5>
                 <p className="text-light">{data.shortDescription}</p>
            </div>
          );
     }else{
       return null;
     }

    };
}

export default FeaturedNews
